export default __webpack_public_path__ + "static/oil-min-902109e7cd7066c64feab586c0853f9a.jpg";